import {ViewName} from "@kta20-core/interfaces/view-name";
import {ViewNames} from "@kta20-knowledge-base/constants";

export const ModuleViews: ViewName[] = [
    {
        name:ViewNames.KB_MAIN_VIEW,
        loader:async()=>{await import(`@kta20-knowledge-base/views/kb-main-view/kb-main-view`);},
        loaded:false
    },
    {
        name:ViewNames.KB_DOCUMENT_RECORD_DETAIL_VIEW,
        loader:async()=>{await import(`@kta20-knowledge-base/views/kb-document-record-detail-view/kb-document-record-detail-view`);},
        loaded:false
    },
    {
        name:ViewNames.KB_RECORD_DETAILS_VIEW,
        loader:async()=>{await import(`@kta20-knowledge-base/views/kb-record-details-view/kb-record-details-view`);},
        loaded:false
    },
    {
        name:ViewNames.KB_DEMO_CARD_VIEW,
        loader:async()=>{await import(`@kta20-knowledge-base/views/kb-demo-card-view/kb-demo-card-view`);},
        loaded:false
    }
];
